import { Button } from '~/components/component-library/Button'
import { SidebarRowDropdown } from '~/components/component-library/internal/Sidebar/components/SidebarRowDropdown'
import { ComponentEntry } from '~/components/component-library/internal/Sidebar/types'

export const SidebarRowButton = (
  props: ComponentEntry & { isActive?: boolean },
) => (
  // group/component: reveals the row's dropdown trigger on hover.
  // prefix spacer: indents the label to align rows under the category.
  <Button
    href={{ path: '/component-library/' + props.id + '/' }}
    variant={props.isActive ? 'secondary' : 'tertiary'}
    size="small"
    fullWidth
    alignLeft
    className="group/component font-normal"
    prefix={<div className="size-4 shrink-0" />}
    suffix={<SidebarRowDropdown {...props} />}
  >
    <span className="flex-1 truncate">{props.name}</span>
  </Button>
)
